import { Theme, useMediaQuery } from '@mui/material';
import { FC, useState } from 'react';

import { CameraCapture } from '@components/CameraCapture';
import Header from '@components/Capture/components/Header';
import { DialogDarkFullscreen } from '@components/DialogDarkFullscreen';

import { ActionComponentProps } from '../../../index';
import ImagePreviewContainer from './ImagePreviewContainer';
import { getButtonConfigs } from './helper';
import { useUploadImage } from './useUploadImage';

type CaptureMode = 'capture' | 'review';

const FinishDeliveryWithImage: FC<ActionComponentProps> = ({ mailpieces, actionStarted, onActionFinish, type }) => {
  const [mode, setMode] = useState<CaptureMode>('capture');
  const [image, setImage] = useState<string | null>(null);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { uploadImage, loading } = useUploadImage(mailpieces, onActionFinish, type);

  const handleImageCapture = (imageSrc: string) => {
    setImage(imageSrc);
    setMode('review');
  };

  const handleCloseAction = () => {
    setImage(null);
    setMode('capture');
    onActionFinish();
  };

  const handleRetake = () => {
    setImage(null);
    setMode('capture');
  };

  const handleComplete = () => {
    if (image) {
      void uploadImage(image);
    }
  };

  const buttons = getButtonConfigs(handleRetake, handleComplete, loading);

  return (
    <DialogDarkFullscreen open={actionStarted}>
      <Header
        onClose={handleCloseAction}
        title={mode === 'capture' ? 'Capture Proof of Delivery' : 'Review'}
        buttons={mode === 'capture' ? [] : buttons}
      />

      {mode === 'capture' && <CameraCapture capture={handleImageCapture} disabled={loading} />}
      {mode === 'review' && image && <ImagePreviewContainer image={image} isMobile={isMobile} buttons={buttons} />}
    </DialogDarkFullscreen>
  );
};

export default FinishDeliveryWithImage;
